import { useQuery } from "react-query";
import { uncoveryApi } from "../../index";

const fetchMapsByAssetId = async ({
  entityId,
  assetId,
  page,
  pageSize,
  searchTerm,
  sortBy,
  orderBy,
  status,
}) => {
  const query = `/entities/${entityId}/assets/${assetId}/cartographies?page=${page}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortBy=${sortBy}&orderBy=${orderBy}&status=${status}`;
  const { data } = await uncoveryApi.get(query);
  return {
    data: data.data,
    hasNextPage: data.pageInfo.hasNextPage,
  };
};

export default function useFetchMapsByAssetId({
  entityId = null,
  assetId = null,
  page = 1,
  pageSize = 20,
  searchTerm = "",
  sortBy = "createdAt",
  orderBy = "desc",
  status = "finished",
}) {
  return useQuery(
    [
      "maps_asset",
      entityId,
      assetId,
      page,
      pageSize,
      searchTerm,
      sortBy,
      orderBy,
      status,
    ],
    () =>
      fetchMapsByAssetId({
        entityId,
        assetId,
        page,
        pageSize,
        searchTerm,
        sortBy,
        orderBy,
        status,
      }),
    {
      enabled: !!entityId && !!assetId,
    }
  );
}
